import React from "react"

import "./styles.scss"

const Container = props => {
  return (<div className='Container'>{props.children}</div>)
}

export default Container
